import '../Auth.scss';
import Login from './login';

interface LoginOverlayPageProps {
  setShowLogin: (showLogin: boolean) => void;
}
// eslint-disable-next-line react/prop-types
const LoginOverlay: React.FC<LoginOverlayPageProps> = ({ setShowLogin }) => {
  return (
    <div className="overlay">
      <Login setShowLogin={setShowLogin} />
    </div>
  );
};

export default LoginOverlay;
